import './ConfirmationMessage.scss';

import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import { useModalContext } from '@/common/contexts/ModalContext';

import {
  ConfirmationMessageDefaultProps,
  ConfirmationMessagePropTypes,
} from './ConfirmationMessage.proptypes';

const ConfirmationMessage = ({
  className,
  description,
  disabled,
  isLoading,
  labelCancel,
  labelSubmit,
  onCancel,
  onSubmit,
  title,
}) => {
  const { t } = useTranslation();
  const { setModalIsOpen } = useModalContext();

  const handleCancel = useCallback(() => {
    onCancel();
    setModalIsOpen(false);
  }, [onCancel, setModalIsOpen]);

  const handleSubmit = useCallback(() => {
    onSubmit();
    setModalIsOpen(false);
  }, [onSubmit, setModalIsOpen]);

  return (
    <div className={className} data-qa-id="confirmation-message">
      <h1 className="rs-modal-title" data-qa-id="confirmation-message-title">
        {title || t('common:messages:actions.confirmation.delete.title')}
      </h1>
      <div
        className="description"
        data-qa-id="confirmation-message-description"
      >
        <p>
          {description ||
            t('common:messages:actions.confirmation.delete.description')}
        </p>
      </div>
      <div className="button-wrapper">
        <Button
          buttonSize="x-large"
          context="button-yes"
          disabled={disabled || isLoading}
          onClick={handleSubmit}
          variant="primary"
        >
          {labelSubmit || t('common:messages:actions.yes')}
        </Button>
        <Button
          buttonSize="x-large"
          context="button-no"
          disabled={disabled || isLoading}
          onClick={handleCancel}
          variant="secondary-light"
        >
          {labelCancel || t('common:messages:actions.no')}
        </Button>
      </div>
    </div>
  );
};

ConfirmationMessage.defaultProps = {
  ...ConfirmationMessageDefaultProps,
};

ConfirmationMessage.propTypes = {
  ...ConfirmationMessagePropTypes,
};

export default ConfirmationMessage;
